<script>
  // M3 snackbar: inverse-surface, single-line text, optional close action.
  // Rendered as a fixed bottom-centered tile via the UiHost. Error toasts
  // also get a copy action (errors are often long/technical and worth
  // pasting into a ticket) and don't auto-dismiss (see ui.svelte.js).
  import { ui } from '../lib/ui.svelte.js';

  let copied = $state(false);
  async function copyText() {
    try {
      await navigator.clipboard.writeText(ui.snackbar?.text || '');
      copied = true;
      setTimeout(() => { copied = false; }, 1500);
    } catch { /* clipboard blocked; nothing useful to do here */ }
  }
</script>

{#if ui.snackbar}
  {#key ui.snackbar.key}
    <div class="snack-wrap" role="status" aria-live="polite">
      <div class="snack" class:error={ui.snackbar.kind === 'error'} class:success={ui.snackbar.kind === 'success'}>
        {#if ui.snackbar.kind === 'error'}
          <span class="material-symbols-outlined snack-icon">error</span>
        {:else if ui.snackbar.kind === 'success'}
          <span class="material-symbols-outlined snack-icon">check_circle</span>
        {/if}
        <span class="snack-text">{ui.snackbar.text}</span>
        {#if ui.snackbar.kind === 'error'}
          <button class="snack-close" onclick={copyText} aria-label="Copy message" title={copied ? 'Copied' : 'Copy message'}>
            <span class="material-symbols-outlined">{copied ? 'check' : 'content_copy'}</span>
          </button>
        {/if}
        <button class="snack-close" onclick={() => ui.dismissSnack()} aria-label="Dismiss">
          <span class="material-symbols-outlined">close</span>
        </button>
      </div>
    </div>
  {/key}
{/if}

<style>
  .snack-wrap {
    position: fixed;
    left: 50%;
    bottom: 24px;
    transform: translateX(-50%);
    z-index: 1100;
    pointer-events: none;
    animation: snack-in 220ms cubic-bezier(.2,.0,0,1);
  }
  .snack {
    pointer-events: auto;
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 280px;
    max-width: 560px;
    padding: 8px 8px 8px 16px;
    background: rgb(var(--md-sys-color-inverse-surface));
    color: rgb(var(--md-sys-color-inverse-on-surface));
    border-radius: 4px;
    box-shadow:
      0 2px 4px 0 rgba(0,0,0,0.30),
      0 4px 12px 4px rgba(0,0,0,0.15);
    font-size: 14px;
    line-height: 20px;
  }
  .snack.error  .snack-icon { color: rgb(var(--md-sys-color-error-container)); }
  .snack.success .snack-icon { color: #b6f2c7; }
  .snack-icon { font-size: 20px; }
  .snack-text { flex: 1; }
  .snack-close {
    width: 32px;
    height: 32px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    color: rgb(var(--md-sys-color-inverse-primary));
    background: transparent;
  }
  .snack-close:hover {
    background: rgb(var(--md-sys-color-inverse-on-surface) / 0.08);
  }
  .snack-close .material-symbols-outlined { font-size: 18px; }

  @keyframes snack-in {
    from { opacity: 0; transform: translate(-50%, 8px); }
    to   { opacity: 1; transform: translate(-50%, 0); }
  }
</style>
